import { gql } from '@apollo/client';

export const GET_SUBSCRIPTION_CONFIGURATION = gql`
  query getSubscriptionConfiguration {
    subscriptionConfiguration
      @rest(
        type: "SubscriptionConfiguration"
        path: "/v4/subscription/configuration"
      ) {
      capabilities
      ad_template_level
    }
  }
`;
